export const environmentDefaults = {
    debug: true,
    name: 'dev'
};
